// components/Modal.js
import React from 'react';
import '../styles/Login.css'; // Optional: separate styles if needed

const Modal = ({
  isOpen,
  onClose,
  title,
  message,
  type = 'error',
  confirmLabel = 'OK',
  cancelLabel = null,
  onConfirm = null
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className={`modal-header ${type}`}>
          <h3>{title}</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <p>{message}</p>
        </div>
        <div className="modal-footer">
          {cancelLabel && (
            <button className="modal-btn cancel" onClick={onClose}>
              {cancelLabel}
            </button>
          )}
          <button className="modal-btn confirm" onClick={handleConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
